export var keyBy = function (array, key) {
    return array.reduce(function (acc, item) {
        acc[item[key]] = item;
        return acc;
    }, {});
};
export var deepEqual = function (a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
};
